type ExceptionDayKind = "holiday" | "working_weekend";

export type CalendarExceptionDay = {
  date: string;
  kind: ExceptionDayKind;
  working: boolean;
};

export type CalendarNominalDay = {
  wday: number;
  working: boolean;
};

export type Calendar = {
  calendarId: number;
  exceptionDays: CalendarExceptionDay[];
  nominalDays: CalendarNominalDay[];
  startDate: string;
};

export enum WeekDay {
  Monday = "monday",
  Tuesday = "tuesday",
  Wednesday = "wednesday",
  Thursday = "thursday",
  Friday = "friday",
  Saturday = "saturday",
  Sunday = "sunday"
}
